<template>
  <base-card body-class="align-items-center" :disabled="!project.stages.details" tabled>
    <template v-slot:header>
      <base-card-heading>
        Project Financials
      </base-card-heading>
      <base-button :class="{ invisible: !complete }" secondary small :to="{ name: 'projects.financials', params: { id: project._id } }">
        Edit
      </base-button>
    </template>
    <template v-if="complete">
      <base-table>
        <colgroup>
          <col width="155" />
        </colgroup>
        <tbody>
          <tr>
            <th>GDV</th>
            <td>{{ $formatting.toCurrency(project.financials.gdv) }}</td>
          </tr>
          <tr>
            <th>Gross Profit</th>
            <td>{{ $formatting.toCurrency(project.financials.profit) }}</td>
          </tr>
          <tr>
            <th>Purchase Price</th>
            <td>{{ $formatting.toCurrency(project.financials.site.purchasePrice) }}</td>
          </tr>
          <tr>
            <th>Total Cost</th>
            <td>{{ $formatting.toCurrency(project.financials.totalCost) }}</td>
          </tr>
        </tbody>
      </base-table>
    </template>
    <template v-else>
      <div class="p-4 text-center">
        <p>
          Please complete the project financials form.
        </p>
        <base-button :to="{ name: 'projects.financials', params: { id: project._id } }" primary small>Complete</base-button>
      </div>
    </template>
  </base-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ProjectFinancialsCard',

  computed: {
    complete () {
      return this.project.stages.financials
    },

    ...mapState({
      project: store => store.core.projects.entity
    })
  }
}
</script>
